import { Trash2 } from 'lucide-react';
import { Button } from '@/components/ui/Button';
import { useTeams, useDeleteTeam } from '@/api/hooks/useTeams';

export function TeamsPage() {
  const { data, isLoading } = useTeams();
  const deleteTeam = useDeleteTeam();

  if (isLoading) {
    return (
      <div
        style={{
          height: 384,
          background: '#e2e8f0',
          borderRadius: 8,
          animation: 'pulse 2s infinite',
        }}
      />
    );
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
      <h1 style={{ fontSize: 22, fontWeight: 700, margin: 0 }}>Teams</h1>

      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
          gap: 16,
        }}
      >
        {data?.length === 0 ? (
          <div
            style={{
              gridColumn: '1 / -1',
              padding: 32,
              background: '#fff',
              borderRadius: 8,
              border: '1px solid #e2e8f0',
              textAlign: 'center',
              fontSize: 13,
              color: '#64748b',
            }}
          >
            No teams yet
          </div>
        ) : (
          data?.map((team) => {
            const spend = team.spend ?? 0;
            const budget = team.max_budget ?? 0;
            const pct = budget > 0 ? Math.min((spend / budget) * 100, 100) : 0;
            return (
              <div
                key={team.team_id}
                style={{
                  padding: 16,
                  background: '#fff',
                  borderRadius: 8,
                  border: '1px solid #e2e8f0',
                  boxShadow: '0 1px 2px rgba(0,0,0,0.04)',
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'flex-start',
                    justifyContent: 'space-between',
                  }}
                >
                  <div>
                    <h3 style={{ margin: 0, fontSize: 14, fontWeight: 600 }}>
                      {team.team_alias ?? team.team_id}
                    </h3>
                    <p style={{ fontSize: 12, color: '#64748b', margin: '4px 0 0' }}>
                      {team.members?.length ?? 0} members
                    </p>
                  </div>
                  <Button
                    variant="ghost"
                    size="icon"
                    onClick={() => {
                      if (
                        confirm(`Delete team ${team.team_alias ?? team.team_id}?`)
                      ) {
                        deleteTeam.mutate(team.team_id);
                      }
                    }}
                  >
                    <Trash2 size={16} color="#dc2626" />
                  </Button>
                </div>

                <div style={{ marginTop: 16, display: 'flex', flexDirection: 'column', gap: 8 }}>
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      fontSize: 13,
                    }}
                  >
                    <span style={{ color: '#64748b' }}>Spend</span>
                    <span>
                      ${spend.toFixed(2)} / {budget > 0 ? `$${budget.toFixed(2)}` : '∞'}
                    </span>
                  </div>
                  {budget > 0 && (
                    <div
                      style={{
                        height: 8,
                        background: '#f1f5f9',
                        borderRadius: 999,
                        overflow: 'hidden',
                      }}
                    >
                      <div
                        style={{
                          height: '100%',
                          background: '#0f172a',
                          width: `${pct}%`,
                          transition: 'width 0.3s',
                        }}
                      />
                    </div>
                  )}
                </div>
              </div>
            );
          })
        )}
      </div>
    </div>
  );
}
